const VALID_SCROLL_BEHAVIORS = new Set(["auto", "smooth", "instant"]);

export const normalizeScrollBehavior = (behavior, fallback = "smooth") => {
  if (VALID_SCROLL_BEHAVIORS.has(behavior)) return behavior;
  return VALID_SCROLL_BEHAVIORS.has(fallback) ? fallback : "smooth";
};
